module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-04.89fc4a81.png";